import { Grid, IconButton, Toolbar } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { Close, Menu } from '@mui/icons-material'
import React from 'react'
import { TopBarLogo } from '../top-bar-logo'

const useStyles = makeStyles((theme) => ({
  sectionMobile: {
    display: 'flex',
    backgroundColor: theme.palette.secondary.main,
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
}))

interface MobileTopBarProps {
  handleMobileMenuOpen: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void
  menuOpen: boolean
}

export const MobileToolBar = ({
  handleMobileMenuOpen,
  menuOpen
}: MobileTopBarProps) => {
  const classes = useStyles()

  return (
    <Toolbar className={classes.sectionMobile}>
      <Grid container justifyContent="space-between">
        <TopBarLogo isMobile />
        <IconButton
          edge="start"
          color="inherit"
          aria-label="menu"
          onClick={handleMobileMenuOpen}
          size="large">
          {menuOpen ? <Close color="primary" /> : <Menu color="primary" />}
        </IconButton>
      </Grid>
    </Toolbar>
  )
}
